(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Login",
                {
                    url: "/Login?{msg}",
                    component: "login",
                    PageTitle: "Login",
                    resolve: {
                        msg: ["$stateParams", function ($stateParams) { return $stateParams.msg; }]
                    }
                });
        }
    ]);

    app.component("login",
        {
            templateUrl: "/App/Login/Login.html",
            controller: loginController,
            bindings: {
                msg: "<"
            }
        });

    loginController.$inject = ["authService", "$state", "$stateParams", "$window", "figAuthSettings"];
    function loginController(authService, $state, $stateParams, $window, figAuthSettings) {
        var $ctrl = this;

        ng.extend($ctrl,
        {
            redirectToLogin: redirectToLogin,
        });

        function redirectToLogin() {
            $ctrl.isLoggingIn = true;
            authService.login();
        }

        this.$onInit = function () {
            if (!$ctrl.msg) redirectToLogin();
        };
    }

})(window.app, window.angular); // jshint ignore:line